<template>
    <div class="resource-nav">
        <div class="container">
            <div class="during-vid-links" v-if="this.$route.name == 'Video' || this.$route.name == 'VideoMap'">
                <router-link :to="{path:'/'}" class="btn btn-icon btn-home" v-if="!resourcesIsActive"><i class="icon-arrow"></i>Back to home</router-link>
                <router-link :to="{name:'VideoMap', params:{year:year, type: type}}" class="btn btn-icon btn-journey" v-if="completed && !resourcesIsActive && this.$route.name != 'VideoMap'">See your journey</router-link>
                <router-link :to="{name:'LandingPage', query:{survey:true}}" class="btn btn-icon btn-survey-nav" v-if="completed && !resourcesIsActive && !completedSurvey">Complete Survey</router-link>
                <button @click="toggleResources" class="btn btn-icon btn-resource" :class="{ 'active-resource' : resourcesIsActive }">{{resourcesToggleLabel}}</button>
            </div>
            
            <div class="account_menu" :class="{ 'not-video' : isNotVideo}">
               
            
                <button @click="toggleAccount" class="btn btn-icon" :class="{ 'active-resource' : accountIsActive, 'btn-account' : isNotVideo}">{{appTextLanguage.account.myaccount[language]}}</button>
                <button class="btn btn-icon responsiveMenuButton" :class="{'btn-account-responsive' : isNotVideo}" @click="toggleResponseMenu">{{menuToggleLabel}}</button> 
                
                <div class="language_buttons" v-if="menuToggleLabel == 'Menu' && currentRouteName !== 'Video'" >
                    <button class="btn btn-icon" :class="{ 'active' : this.isActiveEn  }" @click="setNewLanguage('en')">
                    English
                    </button>
                    <button class="btn btn-icon" :class="{ 'active' : this.isActiveCy }" @click="setNewLanguage('cy')">
                    Cymraeg
                    </button>
                </div>
            </div>
        </div>
        <!-- Transition is core vue that adds the animation class. Animation CSS is included using https://www.npmjs.com/package/vue2-animate -->
        <transition name="slide"
                    enter-active-class="fadeIn"
                    leave-active-class="fadeOut">

            <div class="resources-list" v-show="resourcesIsActive" :class="{ 'resource-show':resourcesIsActive }">
                <div class="resources-inner">
                    <h2>{{appTextLanguage.dashboard.resources[language]}}</h2>
                    <ul v-if="loaded">
                        <li v-for="(resource,index) in videoResources">
                            <a :href="resource.url" target="_blank" @click="logResourceDownload(index, resource)" @click.middle="logResourceDownload(index, resource)">{{resource.filename}}</a>
                        </li>
                    </ul>
                </div>
            </div>

        </transition>
        <transition name="slide"
                    enter-active-class="fadeIn"
                    leave-active-class="fadeOut">
            <div class="resources-list responsivemenu" v-show="responsiveMenu" :class="{ 'resource-show':responsiveMenu }" >
                <div class="resources-inner">
                    <ul>
                        <li v-if="this.$route.name == 'Video' || this.$route.name == 'VideoMap'">
                            <router-link :to="{path:'/'}" class="btn btn-icon" v-if="!resourcesIsActive" v-on:click.native="hideMenu">Back to home</router-link>
                        </li>
                        <li v-if="this.$route.name == 'Video' || this.$route.name == 'VideoMap'">
                            <router-link :to="{name:'VideoMap', params:{year:year, type: type}}" class="btn btn-icon" v-if="completed && !resourcesIsActive && this.$route.name != 'VideoMap'" v-on:click.native="hideMenu">See your journey</router-link>
                        </li>
                        <li v-if="this.$route.name == 'Video' || this.$route.name == 'VideoMap'">
                            <router-link :to="{name:'LandingPage', query:{survey:true}}" class="btn btn-icon" v-if="completed && !resourcesIsActive && !completedSurvey" v-on:click.native="hideMenu">Complete Survey</router-link>
                        </li>
                        <li v-if="this.$route.name == 'Video' || this.$route.name == 'VideoMap'">
                            <button @click="toggleResources" class="btn btn-icon" :class="{ 'active-resource' : resourcesIsActive }">{{resourcesToggleLabel}}</button>
                        </li>
                        <li><button @click="toggleAccount" class="btn btn-icon" :class="{ 'active-resource' : accountIsActive }">My Account</button></li>
                        <li><button @click="logout" class="btn btn-icon" :class="{ 'active-resource' : accountIsActive }">Logout</button></li>
                    </ul>
                </div>
            </div>
        </transition>
        <modal name="myaccount-form" id="regModal" 
            reset=true
            transition="fade"
            overlayTransition="fade"
            height="auto"
            scrollable=true
            width="600px"
            pivotY=0.7>
            <div class="modal-close" @click="closeAccount">
                <span></span>
            </div>
            <form @submit.prevent="updateAccount(form)" key="1" id="registationForm" autocomplete="new-password" class="accountForm">
                <div class="row inputs">
                    <input type="hidden" name="address_1" v-validate.disable="'required'" v-model.trim="form.address_1" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="address_2" v-model.trim="form.address_2" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="city" v-model.trim="form.city" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <input type="hidden" name="postcode" v-validate.disable="'required'" v-model.trim="form.postcode" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')">
                    <h3 class="formCategory">{{appTextLanguage.account.accountTitle[language]}}</h3>
                    
                    <div class="col-12 fullwidth selectbox">
                        <label for="account_type" class="form-label">{{appTextLanguage.account.accountType[language]}}</label>
                        <select v-validate.disable="'required'" v-model.trim="form.account_type" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('account_type') }" name="account_type" id="account_type" autocomplete="new-password">
                            <option value="centre">{{appTextLanguage.account.accountTypeOption1[language]}}</option>
                            <option value="parent">{{appTextLanguage.account.accountTypeOption2[language]}}</option>
                            <option value="other">{{appTextLanguage.account.accountTypeOption3[language]}}</option>
                        </select>
                        <span class="help is-danger"><span v-if="errors.has('account_type')">{{appTextLanguage.account.accountTypeRequired[language]}}</span></span>
                    </div>

                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth" v-if="!centreFallback && form.account_type == 'centre'" key="auto">
                            <label for="centre_lookup" class="form-label">{{appTextLanguage.account.findCentre[language]}}</label>
                            <input class="form-input"
                                :class="{'input': true, 'is-danger': errors.has('centre_lookup') }" 
                                type="text" 
                                name="centre_lookup"
                                id="centre_lookup" 
                                autocomplete="new-password" 
                                v-model="form.centre_search_term"
                                v-validate.disable="'required'"
                                @blur="clearCentreSuggestions"
                                @input="getCentreSuggestions"
                                @keydown.esc="clearCentreSearch"
                                v-bind:placeholder="appTextLanguage.account.centrePlaceholder[language]" 
                                @change="centreSearched"
                            />
                            
                            <ul v-if="centreSuggestions.length > 0" class="suggestions">
                                <li v-for="suggestion in centreSuggestions" :key="suggestion.id" @click="selectSuggestion(suggestion)">
                                    <a>{{ suggestion.name }}</a>
                                </li>
                            </ul>

                            <span class="help not-found" v-if="centreSearchTry" @click="centreAddressFallback">{{appTextLanguage.introform.findCentre[language]}}</span>
                            <span class="help is-danger"><span v-if="errors.has('centre_name') || errors.has('centre_postcode') || errors.has('centre_lookup')">{{appTextLanguage.account.centreAddressRequired[language]}}</span></span>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth fallback" v-if="centreFallback && form.account_type == 'centre'">
                            <div class="col-xs-2" >
                                <label for="centre_name" class="form-label">{{appTextLanguage.account.centreName[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.centre_name" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('centre_name') }" type="text" name="centre_name"
                                    id="centre_name" autocomplete="new-password"/>
                                <span class="help not-found"  @click="centreAddressFallback">{{appTextLanguage.account.autoFindCentre[language]}}</span>
                                <span class="help is-danger"><span v-if="errors.has('centre_name')">{{appTextLanguage.account.centreNameRequired[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="centre_postcode" class="form-label">{{appTextLanguage.account.centrePostcode[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.centre_postcode" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('centre_postcode') }" type="text" name="centre_postcode"
                                    id="centre_postcode" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('centre_postcode')">{{appTextLanguage.account.centrePostcodeRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>
                    
                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth fallback" v-if="form.account_type == 'other'">
                            <div class="col-12 fullwidth selectbox">
                                <label for="organisation_type" class="form-label">{{appTextLanguage.account.orgType[language]}}</label>
                                <select v-bind:title="appTextLanguage.account.orgTypeDetail[language]" v-validate.disable="'required'" v-model.trim="form.organisation_type" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('organisation_type') }" name="organisation_type" id="organisation_type" autocomplete="new-password">
                                    <option value="charity">{{appTextLanguage.account.orgTypeOption1[language]}}</option>
                                    <option value="guides">{{appTextLanguage.account.orgTypeOption2[language]}}</option>
                                    <option value="youth_organisation">{{appTextLanguage.account.orgTypeOption3[language]}}</option>
                                    <option value="credit_union">{{appTextLanguage.account.orgTypeOption4[language]}}</option>
                                    <option value="local_authority">{{appTextLanguage.account.orgTypeOption5[language]}}</option>
                                    <option value="bank">{{appTextLanguage.account.orgTypeOption6[language]}}</option>
                                    <option value="children_need">{{appTextLanguage.account.orgTypeOption7[language]}}</option>
                                    <option value="placement">{{appTextLanguage.account.orgTypeOption8[language]}}</option>
                                    <option value="hospital_school">{{appTextLanguage.account.orgTypeOption9[language]}}</option>
                                    <option value="young_enterprise_staff">{{appTextLanguage.account.orgTypeOption10[language]}}</option>
                                    <option value="other">{{appTextLanguage.account.orgTypeOption11[language]}}</option>
                                </select>
                                <span class="help is-danger"><span v-if="errors.has('organisation_type')">{{appTextLanguage.account.orgTypeRequired[language]}}</span></span>
                            </div>

                            <div class="col-xs-2">
                                <label for="organisation" class="form-label">{{appTextLanguage.account.orgName[language]}}</label>
                                <input v-bind:title="appTextLanguage.account.orgNameDetail[language]" v-validate.disable="'required'" v-model.trim="form.organisation" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('organisation') }" type="text" name="organisation"
                                    id="organisation" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('organisation')">{{appTextLanguage.account.orgTypeRequired[language]}}</span></span>
                            </div>

                            <div class="col-xs-2 selectbox">
                                <label for="role" class="form-label">{{appTextLanguage.account.role[language]}}</label>
                                <select v-validate.disable="'required'" v-model.trim="form.role" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('role') }" name="role" id="role" autocomplete="new-password">
                                    <option value="early_years">{{appTextLanguage.account.roleOption1[language]}}</option>
                                    <option value="primary">{{appTextLanguage.account.roleOption2[language]}}</option>
                                    <option value="secondary">{{appTextLanguage.account.roleOption3[language]}}</option>
                                    <option value="teacher_other">{{appTextLanguage.account.roleOption4[language]}}</option>
                                    <option value="teacher_assistant">{{appTextLanguage.account.roleOption5[language]}}</option>
                                    <option value="head">{{appTextLanguage.account.roleOption6[language]}}</option>
                                    <option value="depty">{{appTextLanguage.account.roleOption7[language]}}</option>
                                    <option value="subject_leader">{{appTextLanguage.account.roleOption8[language]}}</option>
                                    <option value="year_group_leader">{{appTextLanguage.account.roleOption9[language]}}</option>
                                    <option value="home_educator">{{appTextLanguage.account.roleOption10[language]}}</option>
                                    <option value="tutor">{{appTextLanguage.account.roleOption11[language]}}</option>
                                    <option value="youth_worker">{{appTextLanguage.account.roleOption12[language]}}</option>
                                    <option value="other">{{appTextLanguage.account.roleOption13[language]}}</option>
                                </select>
                                <span class="help is-danger"><span v-if="errors.has('role')">{{appTextLanguage.account.orgRoleRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>
                   
                    <div class="col-12 fullwidth selectbox multiple">
                        <label for="age_group" class="form-label">{{appTextLanguage.account.ageGroup[language]}}</label>

                        <v-select 
                            multiple 
                            v-bind:title="appTextLanguage.account.ageGroupDetail[language]" 
                            v-validate.disable="'required'" 
                            v-model.trim="form.age_group" 
                            class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('age_group') }" 
                            name="age_group" 
                            id="age_group" 
                            autocomplete="new-password"
                            :reduce="(option) => option.code"
                            :options="[
                                {
                                    code: 'pre_reception', label: appTextLanguage.account.ageOption1[language],
                                },
                                {
                                    code: 'reception', label: appTextLanguage.account.ageOption2[language],
                                },
                                {
                                    code: 'y1', label: appTextLanguage.account.ageOption3[language]
                                },
                                {
                                    code: 'y2', label: appTextLanguage.account.ageOption4[language]
                                },
                                {
                                    code: 'y3', label: appTextLanguage.account.ageOption5[language]
                                },
                                {
                                    code: 'y4', label: appTextLanguage.account.ageOption6[language]
                                },
                                {
                                    code: 'y5', label: appTextLanguage.account.ageOption7[language]
                                },
                                {
                                    code: 'y6', label: appTextLanguage.account.ageOption8[language]
                                },
                                {
                                    code: 'y7', label: appTextLanguage.account.ageOption9[language]
                                },
                                {
                                    code: 'y8', label: appTextLanguage.account.ageOption10[language]
                                },
                                {
                                    code: 'y9', label: appTextLanguage.account.ageOption11[language]
                                },
                                {
                                    code: 'y10', label: appTextLanguage.account.ageOption12[language]
                                },
                                {
                                    code: 'y11', label: appTextLanguage.account.ageOption13[language]
                                },
                                {
                                    code: 'y12', label: appTextLanguage.account.ageOption14[language]
                                },
                                {
                                    code: 'y13', label: appTextLanguage.account.ageOption15[language]
                                },
                                {
                                    code: '18_over', label: appTextLanguage.account.ageOption16[language]
                                }
                            ]">
                        </v-select>
                        <span class="help is-danger"><span v-if="errors.has('age_group')">{{appTextLanguage.account.ageGroupRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2">
                        <label for="number_of_students" class="form-label">{{appTextLanguage.account.numberYoung[language]}}</label>
                        <input v-bind:title="appTextLanguage.account.numberYoungDetail[language]" v-validate.disable="'required|numeric'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('number_of_students') }" v-model.trim="form.number_of_students"
                            type="number" min=0 name="number_of_students" id="number_of_students" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('number_of_students')">{{appTextLanguage.account.numberYoungRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2">
                        <label for="number_of_educators" class="form-label">{{appTextLanguage.account.numberEducators[language]}}</label>
                        <input v-bind:title="appTextLanguage.account.numberEducatorsDetail[language]" v-validate.disable="'required|numeric'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('number_of_educators') }" v-model.trim="form.number_of_educators"
                            type="number" min=0 name="number_of_educators" id="number_of_educators" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('number_of_educators')">{{appTextLanguage.account.numberEducatorsRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2 selectbox">
                        <label for="where_did_you_hear" class="form-label">{{appTextLanguage.account.whereDidYouHear[language]}}</label>
                        <select v-validate.disable="'required'" v-model.trim="form.where_did_you_hear" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('where_did_you_hear') }" name="where_did_you_hear" id="where_did_you_hear" autocomplete="new-password">
                            <option value="email_campaign">{{appTextLanguage.account.whereDidYouHearOption1[language]}}</option>
                            <option value="advert">{{appTextLanguage.account.whereDidYouHearOption2[language]}}</option>
                            <option value="event">{{appTextLanguage.account.whereDidYouHearOption3[language]}}</option>
                            <option value="facebook">{{appTextLanguage.account.whereDidYouHearOption4[language]}}</option>
                            <option value="linkedIn">{{appTextLanguage.account.whereDidYouHearOption5[language]}}</option>
                            <option value="twitter ">{{appTextLanguage.account.whereDidYouHearOption6[language]}}</option>
                            <option value="other">{{appTextLanguage.account.whereDidYouHearOption7[language]}}</option>
                            <option value="taken_part_before">{{appTextLanguage.account.whereDidYouHearOption8[language]}}</option>
                            <option value="tv_radio">{{appTextLanguage.account.whereDidYouHearOption9[language]}}</option>
                            <option value="mouth">{{appTextLanguage.account.whereDidYouHearOption10[language]}}</option>
                            <option value="ye_staff">{{appTextLanguage.account.whereDidYouHearOption11[language]}}</option>
                        </select>
                        <span class="help is-danger"><span v-if="errors.has('where_did_you_hear')">{{appTextLanguage.account.whereDidYouHearRequired[language]}}</span></span>
                    </div>
                   
                    <transition name="fade" mode="out-in">
                        <div class="col-12 fullwidth" v-if="!fallback && (form.account_type == 'parent' || form.account_type == 'other')" key="auto">
                            <label for="lookup" class="form-label">{{appTextLanguage.account.orgAddress[language]}}</label>
                            <input class="form-input"
                                :class="{'input': true, 'is-danger': errors.has('lookup') }" type="text" name="lookup"
                                id="lookup" autocomplete="new-password" v-model.trim="form.lookup" v-bind:placeholder="appTextLanguage.account.addressPlaceholder[language]" @change="searched"/>
                            <span class="help not-found" v-if="searchTry" @click="addressFallback">{{appTextLanguage.account.findAddress[language]}}</span>
                            <span class="help is-danger"><span v-if="errors.has('address_1') || errors.has('postcode') || errors.has('lookup')">{{appTextLanguage.account.orgAddressRequired[language]}}</span></span>
                        </div>
                        <div class="col-12 fullwidth fallback" v-if="fallback && (form.account_type == 'parent' || form.account_type == 'other')" key="fallback">
                            <div class="col-xs-2" >
                                <label for="address_1" class="form-label">{{appTextLanguage.account.addressLine1[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.address_1" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('address_1') }" type="text" name="address_1"
                                    id="address_1" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('address_1')">{{appTextLanguage.account.addressLine1Required[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="address_2" class="form-label">{{appTextLanguage.account.addressLine2[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.address_2" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('address_2') }" type="text" name="address_2"
                                    id="address_2" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('address_2')">{{appTextLanguage.account.addressLine2Required[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="city" class="form-label">{{appTextLanguage.account.city[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.city" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('city') }" type="text" name="city"
                                    id="city" autocomplete="new-password"/>
                                <span class="help not-found"  @click="addressFallback">{{appTextLanguage.account.autoFindAddress[language]}}</span>
                                <span class="help is-danger"><span v-if="errors.has('city')">{{appTextLanguage.account.cityRequired[language]}}</span></span>
                            </div>
                            <div class="col-xs-2" >
                                <label for="postcode" class="form-label">{{appTextLanguage.account.postCode[language]}}</label>
                                <input v-validate.disable="'required'" v-model.trim="form.postcode" class="form-input"
                                    :class="{'input': true, 'is-danger': errors.has('postcode') }" type="text" name="postcode"
                                    id="postcode" autocomplete="new-password"/>
                                <span class="help is-danger"><span v-if="errors.has('postcode')">{{appTextLanguage.account.postcodeRequired[language]}}</span></span>
                            </div>
                        </div>
                    </transition>
                    <h3 class="formCategory">{{appTextLanguage.account.personalInfo[language]}}</h3>

                    <div class="col-xs-2">
                        <label for="first_name" class="form-label">{{appTextLanguage.account.firstName[language]}}</label>
                        <input v-validate.disable="'required'" v-model.trim="form.first_name" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('first_name') }" type="text" name="first_name"
                            id="first_name" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('first_name')">{{appTextLanguage.account.firstNameRequired[language]}}</span></span>
                    </div>
                    <div class="col-xs-2">
                        <label for="last_name" class="form-label">{{appTextLanguage.account.lastName[language]}}</label>
                        <input v-validate.disable="'required'" v-model.trim="form.last_name" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('last_name') }" type="text" name="last_name"
                            id="last_name" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('last_name')">{{appTextLanguage.account.lastNameRequired[language]}}</span></span>
                    </div>

                    <div class="col-xs-2">
                        <label for="email" class="form-label">{{appTextLanguage.account.emailAddress[language]}}</label>
                        <input v-validate.disable="'required|email'" class="form-input"
                            :class="{'input': true, 'is-danger': errors.has('email') }" v-model.trim="form.email"
                            type="email" name="email" id="email" autocomplete="new-password"/>
                        <span class="help is-danger"><span v-if="errors.has('email')">{{appTextLanguage.account.emailRequired[language]}}</span></span>
                    </div>
                    <div class="col-xs-2">
                        <a class="forgottenPass" @click="changePassword()">{{appTextLanguage.account.changePassword[language]}}</a>
                    </div>
                </div>
                <div class="row checkboxs">
                    <div class="col-xs-12 checkbox">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" v-model="form.contactPreferences">
                                {{appTextLanguage.account.contactPreferences[language]}}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row submit">
                    <div class="col-xs-12 btn-holder">
                        <div class="btn-wrap btn-wrap-start">
                            <input type="submit" v-model="appTextLanguage.account.updateInfo[language]" class="btn btn-primary"/>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row submit force-bottom">
                <div class="col-xs-12 btn-holder">
                    <div class="btn-wrap btn-wrap-start logoutBtn">
                        <input type="submit" v-model="appTextLanguage.account.logout[language]" class="btn btn-primary" @click="logout()"/>
                    </div>
                </div>
            </div>
        </modal>
    </div>

</template>

<script>
    import { mapMutations, mapActions, mapState } from 'vuex';

    const RESOURCES_TOGGLE_LABEL_DEFAULT = "View resources";
    import Data from '../../plugins/data.js';
    export default {
        name: 'ResourcesNavigation',
        props: ['VideoData'],
        data: function () {
            return {
                language: null,
                isActiveEn: null,
                isActiveCy: null,
                appTextLanguage: null,
                videoResources: [],
                loaded: false,
                resourcesIsActive : false,
                responsiveMenu: false,
                accountIsActive: false,
                resourcesToggleLabel : RESOURCES_TOGGLE_LABEL_DEFAULT,
                menuToggleLabel: 'Menu',
                currentVideoId : this.$route.params['videoId'],
                form: {
                    first_name: '',
                    last_name: '',
                    organisation: null,
                    organisation_type: null,
                    age_group: '',
                    number_of_students: 0,
                    number_of_educators: 0,
                    where_did_you_hear: null,
                    role: null,
                    lookup: '',
                    address_1: '',
                    address_2: '',
                    city: '',
                    postcode: '',
                    email: null,
                    password: null,
                    contactPreferences: false,
                    account_type: null,
                    centre_id: null,
                    centre_urn: null,
                    centre_name: null,
                    centre_postcode: null,
                    centre_search_term: '',
                },
                searchTry: false,
                centreSearchTry: false,
                fallback: false,
                centreFallback: false,
                centreSuggestions: [],
                centreSelected: null,
                timeoutId: null,
            }
        },
        methods: {
            ...mapMutations({
                setLanguage: 'setLanguage',
             }),
             ...mapActions({
                getAppText: 'getAppText'
            }),
            setNewLanguage(language="")
            {       
                this.setLanguage(language);
                this.$store.state.language = language; 
            },
            
            getAppTextByLanguage(language="")
            {
                if(language == "cy")
                {  
                this.$store.state.appText = this.$store.state.appTextCy;  
                }
                else
                {
                this.$store.state.appText = this.$store.state.appTextEn;
                }
            },
            addressFallback() {
                // Show fallback fields
                this.fallback = !this.fallback;
                console.log(this.fallback);
                if(!this.fallback) {
                    setTimeout(() => {
                        this.loqateSetup();
                    }, 1500);
                }
            },
            centreAddressFallback() {
                // Show centre fallback fields
                this.centreFallback = !this.centreFallback;
                console.log(this.centreFallback);
                if(!this.centreFallback) {
                    setTimeout(() => {
                        console.log('centreAddressFallback');
                    }, 1500);
                }
            },
            searched() {
                this.searchTry = true;
            },
            centreSearched() {
                this.centreSearchTry = true;
            },
            toggleResources : function(){
                this.resourcesIsActive = !this.resourcesIsActive;
                this.resourcesToggleLabel = this.resourcesIsActive ? "Close resources" : RESOURCES_TOGGLE_LABEL_DEFAULT;
                this.menuToggleLabel = this.responsiveMenu ? 'Close resources' : 'Menu';
                this.responsiveMenu = false;
            },
            toggleResponseMenu: function() {
                 this.responsiveMenu = !this.responsiveMenu;
                 this.menuToggleLabel = this.responsiveMenu ? 'Close Menu' : 'Menu';
                 this.resourcesIsActive = false;
                 this.resourcesToggleLabel = this.resourcesIsActive ? "Close resources" : RESOURCES_TOGGLE_LABEL_DEFAULT;
            },
            hideMenu: function() {
                this.responsiveMenu = false;
                this.menuToggleLabel = 'Menu';
            },
            closeAccount() {
                this.$modal.hide('myaccount-form');
            },
            toggleAccount: function() {
                this.responsiveMenu = false;
                this.menuToggleLabel = 'Menu';
                this.accountIsActive = !this.accountIsActive;
                
                this.$modal.show('myaccount-form');

                this.loqateSetup();
            },
            loqateSetup() {
                let fields = [
                    { element: "lookup", field: "{Line1}{, {Line2}}{, {Line3}}{, {City}}{, {PostalCode}}", mode: pca.fieldMode.SEARCH | pca.fieldMode.POPULATE },
                    { element: "address_1", field: "Line1", mode: pca.fieldMode.POPULATE},
                    { element: "address_2", field: "Line2", mode: pca.fieldMode.POPULATE},
                    { element: "postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE},
                    { element: "city", field: "City", mode: pca.fieldMode.POPULATE}
                ];
                let options = {
                    key: process.env.LOQATE_KEY
                }
                this.control = new pca.Address(fields, options);
                setTimeout(() => {
                    this.control.load();
                }, 500);

                let vm = this;
                this.control.listen("populate", function(address, variations) {
                    vm.form.postcode = address.PostalCode;
                    vm.form.address_1 = address.Line1;
                    vm.form.address_2 = address.Line2;
                    vm.form.city = address.City;
                });
            },
            getVideoResources () {
                // Load resources for year + type
                this.videoResources = this.$store.getters.getResourcesFor(this.$route.params['year'], this.$route.params['type']);
                this.loaded = true;
            },
            logResourceDownload(index, resource) {
                resource.type = this.$route.params['type'];
                resource.year = this.$route.params['year'];
                resource.index = index;
                console.log(resource);
                // // Add to store
                this.$store.dispatch('addResourceDownload', resource);
            },
            updateAccount(formData) {
                this.$validator.validateAll().then((result) => {

                    if (result) {
                        
                        // all valid
                        this.persistFormData(formData);
                    }
                    
                    // errors to correct
                });

            },
            persistFormData(formData) {
                console.log('formData');
                console.log(formData);

                // Send to WP
                let data = {};
                data.first_name = formData.first_name;
                data.last_name = formData.last_name;
                data.organisation_name = formData.organisation;
                data.organisation_type = formData.organisation_type;
                data.age_group = formData.age_group;
                data.role = formData.role;
                data.number_of_students = formData.number_of_students;
                data.address_1 = this.form.address_1;
                data.address_2 = this.form.address_2;
                data.city = this.form.city;
                data.postcode = this.form.postcode;
                data.contact_preference = formData.contactPreferences;
                data.email = formData.email;

                data.account_type = formData.account_type;
                data.number_of_educators = formData.number_of_educators;
                data.where_did_you_hear = formData.where_did_you_hear;
                
                // only send this data if 'fallback' fields weren't visible
                data.centre_id = (!this.centreFallback ? formData.centre_id : null);
                data.centre_urn = (!this.centreFallback ? formData.centre_urn : null);
                data.establishment_name = (!this.centreFallback ? formData.centre_search_term : null);
                
                // only send this data if 'fallback' fields were visible
                data.centre_name = (this.centreFallback ? formData.centre_name : null);
                data.centre_postcode = (this.centreFallback ? formData.centre_postcode : null);

                var token = this.$store.getters.getBearerToken;

                this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/update-account', data, {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    },
                    timeout: 60000
                }).then(function (response) {
                    console.log(response.data);
                    if(response.data.code == 200) {
                        this.$store.commit('setAccountInfo', data);

                        if(formData.age_group == 'all_through') {
                            formData.age_group = 'primary';
                        }

                        this.form.lookup = data.address_1 + (data.address_2 != null && data.address_2 != '' ? ', ' + data.address_2 : '') + ', ' + data.city + ', ' + data.postcode;
                        
                        this.$store.commit('setMMWType', formData.age_group);
                        this.$modal.hide('myaccount-form');
                        this.$toasted.show(this.appTextLanguage.account.accountUpdated[this.language], {
                            duration: 6000,
                            position: 'top-center',
                            type: "success",
                            action: {
                                text: this.appTextLanguage.introform.close[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        });
                    }
                },function (response) {
                    // Error
                   if(response.data != null && response.data != '' && response.data.data.status == 400){
                        var field = response.data.data.field;
                        var message = response.data.message;
                        if(field == 'email') {
                            this.$validator.errors.add({
                                id: 'email',
                                field: 'email',
                                msg: message,
                                scope: this.$options.scope,
                            });
                        }else if (field == 'register') {
                            this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                        }
                    } else {
                        this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                    }
                });
            },
            logout() {
                let query = Object.assign({}, this.$route.query);
                delete query.survey;
                this.$router.replace({ query });

                this.$store.commit('setLostAccess');
                this.$toasted.show(this.appTextLanguage.account.accountLoggedOut[this.language], {
                    duration: 4000,
                    position: 'top-center',
                    type: "info",
                    action: {
                        text: this.appTextLanguage.introform.close[this.language],
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                });

                setTimeout(() => {
                    this.$router.go();
                }, 200);
                
            },
            changePassword() {
                var token = this.$store.getters.getBearerToken;
                var data = {};
                data.language = this.language;
                this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/lostpassword', data, {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    },
                    timeout: 60000
                }).then(function (response) {
                    console.log(response.data);
                    if(response.data.code == 200) {
                        // 
                        this.$modal.hide('myaccount-form');
                        this.$toasted.show(this.appTextLanguage.account.passwordInstructions[this.language], {
                            duration: 6000,
                            position: 'top-center',
                            type: "success",
                            action: {
                                text: this.appTextLanguage.introform.close[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        });
                    } else {
                        this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                    }
                },function (response) {
                    // Error
                    console.log(response.data);
                    this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                });
            },
            getCentreSuggestions()
            {
                this.centreSuggestions = [];

                // Clear any pending timeouts
                clearTimeout(this.timeoutId);

                if (!this.form.centre_search_term) return;

                // Schedule the API call after 300 mseconds
                this.timeoutId = setTimeout(async () => {
                    this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/school-suggestions', {centre_name: this.form.centre_search_term}, {timeout: 60000, hidden:true, chained: true}).then(function (response)
                    {    
                        console.log(response.data);

                        if(response.data.code == 200)
                        {
                            console.log('success');
                            this.centreSuggestions = response.data.suggestions;

                            console.log(this.centreSuggestions);
                        }

                        console.log('test');
                        this.$global.loading = false;

                    },function (response) {
                        // error callback
                        console.log('error');
                        this.$global.loading = false;
                    });
                }, 300);
            },
            clearCentreSuggestions() {
                // Clear any pending timeouts
                clearTimeout(this.timeoutId);

                // small timeout so it doesn't remove the suggestions before the 'onclick' event
                setTimeout(() => 
                {
                    this.centreSuggestions = [];
                    
                    // shool name was manually changed after selected
                    if(this.centreSelected && this.form.centre_search_term != this.centreSelected)
                    {
                        this.form.centre_search_term = this.centreSelected;
                    }

                    // empty search field if no option was selected from the drop-down
                    console.log(this.form.centre_id);

                    if(!this.form.centre_id)
                    {
                        this.form.centre_search_term = '';   
                    }    
                }, 400);
            },
            clearCentreSearch() {
                this.form.centre_search_term = '';
                this.centreSuggestions = [];
            },
            selectSuggestion(suggestion)
            {
                this.centreSelected = suggestion.name;
                console.log('selectSuggestion');
                console.log(suggestion);
                this.form.centre_search_term = suggestion.name;
                this.form.centre_id = suggestion.id;
                this.form.centre_urn = suggestion.urn;
                this.centreSuggestions = [];
            },
        },
        created(){
        

            this.isNotVideo = true;

            if(this.$route.name == 'Video') {
              this.isNotVideo = false; 
            }

            this.year = this.$route.params['year'];
            this.type = this.$route.params['type'];
            if(this.$route.params['year'] != null && this.$route.params['type'] != null){
                 this.getVideoResources();
            }
           
            // Check local storage
            var accountInfo = this.$store.getters.getAccountInfo;

            console.log('accountInfo');
            console.log(accountInfo);

            if(accountInfo != null)
            {
                this.form.organisation = accountInfo.organisation_name;
                this.form.organisation_type = accountInfo.organisation_type;
                this.form.age_group = accountInfo.age_group;
                this.form.role = accountInfo.role;
                this.form.number_of_students = accountInfo.number_of_students;
                this.form.address_1 = accountInfo.address_1;
                this.form.address_2 = accountInfo.address_2;
                this.form.city = accountInfo.city;
                this.form.postcode = accountInfo.postcode;
                this.form.contactPreferences = accountInfo.contact_preference;
                this.form.email = accountInfo.email;

                this.form.first_name = accountInfo.first_name;
                this.form.last_name = accountInfo.last_name;
                this.form.account_type = accountInfo.account_type;
                this.form.where_did_you_hear = accountInfo.where_did_you_hear;
                this.form.centre_id = accountInfo.centre_id;
                this.form.centre_urn = accountInfo.centre_urn;
                this.form.centre_name = accountInfo.centre_name;
                this.form.centre_postcode = accountInfo.centre_postcode;
                this.form.centre_lookup = accountInfo.establishment_name;
                this.form.number_of_educators = accountInfo.number_of_educators;
                this.form.centre_search_term = accountInfo.establishment_name;
                this.centreSelected = this.form.centre_search_term;

                const address_2 = (accountInfo.address_2 != null && accountInfo.address_2 != '' ? ', ' + accountInfo.address_2 : '');
                const account_city = (accountInfo.city != null && accountInfo.city != '' ? ', ' + accountInfo.city : '');
                const account_postcode = (accountInfo.postcode != null && accountInfo.postcode != '' ? ', ' + accountInfo.postcode : '');

                this.form.lookup = accountInfo.address_1 + address_2 + account_city + account_postcode;
            };

            if(this.form.centre_name)
            {
                this.centreFallback = true;
            }

            console.log('centreFallback');
            console.log(this.centreFallback);

            // Set default language
            const stateApp = this.$store.state;
            const language = this.$store.getters.getLanguage;

            this.setLanguage(language);

          
            const getAppTextByLanguage = this.getAppTextByLanguage;

            // start page loader
            stateApp.languageLoaded = false;

            this.appTextLanguage = this.$store.getters.getAppTextLanguage;
            this.language = this.$store.getters.getLanguage;

            if (this.language == 'en') {
                this.isActiveEn = true;
            }
            else {
                this.isActiveCy = true;
            }
            

        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            },
            completed (){
                return (this.$route.fullPath != '/map') ? this.$store.getters.getCompleted(this.$route.params['year'], this.$route.params['type']) : false;
            },
            completedSurvey() {

                    this.status = this.$store.getters.getStatus;
                    if(this.status == 'pre') {
                        this.survey = this.$store.getters.getSurveyCompletedGeneral;
                        return this.survey == this.$store.getters.getSurveyGeneralID;
                    }
                    else {
                        this.survey = this.$store.getters.getSurveyCompletedLive;
                        return this.survey == this.$store.getters.getSurveyLiveID;
                    }

                
            }
        },
        mounted() {
            let loqateScript = document.createElement('script')
            loqateScript.setAttribute('src', 'https://services.postcodeanywhere.co.uk/js/address-3.91.js')
            document.head.appendChild(loqateScript)
        },
        watch: {
            $route (to, from) {
                this.year = this.$route.params['year'];
                this.type = this.$route.params['type'];
                if(this.$route.params['year'] != null && this.$route.params['type'] != null){
                    this.getVideoResources();
                }

                if(this.$route.name == 'Video') {
                    this.isNotVideo = false; 
                }
                else {
                    this.isNotVideo = true; 
                }
            },
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;
                document.documentElement.lang = this.language;

                if (this.language == 'en') {
                    this.isActiveEn = true;
                    this.isActiveCy = false;
                }
                else {
                    this.isActiveCy = true;
                    this.isActiveEn = false;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "https://services.postcodeanywhere.co.uk/css/address-3.91.css";
</style>



// WEBPACK FOOTER //
// src/components/global/ResourcesNavigation.vue